import { MatSort } from '@angular/material/sort';
import { ObjHlp } from 'src/lib/fliko/helpers/object.helper';
import { ReplaceMap } from 'src/lib/fliko/interfaces/replaceMap';
import { StrValue } from 'src/lib/fliko/types/typeish.type';

export interface IDataTableConfig {
  dataColumns: DataTableColumn[];
  paginator: boolean;
  export: boolean;
  newStyle: boolean;
  onClickHighlight: boolean;
  multiTemplateDataRows: boolean;
  searchKeyNames: string[];
  filterPredicate: (obj: any, settings: any) => boolean;
}

export class DataTableConfig implements IDataTableConfig {
  public dataColumns: DataTableColumn[] = [];
  public paginator = false;
  public export = false;
  public newStyle = false;
  public onClickHighlight = false;
  public multiTemplateDataRows = false;
  public searchKeyNames: string[] = ['fullName'];
  public filterPredicate: (obj: any, settings: any) => boolean = () => true;

  constructor(obj: Partial<IDataTableConfig>) {
    for (const key of ObjHlp.keys(obj)) {
      if (obj[key]) (this as any)[key] = obj[key];
    }
    if (obj.dataColumns?.length) {
      this.dataColumns = obj.dataColumns.map((data: DataTableColumn) => new DataTableColumn(data));
    }
  }
}

export class DataTableColumn {
  public name: LocLabel;
  public value: string;
  public sort?: boolean;
  public customSorter?: (data: any[], matSort: MatSort) => any[];
  public valueIsNumber?: boolean = false;
  public width?: number;
  public icon?: string;
  public hidden?: boolean = false;

  constructor(obj: DataTableColumn) {
    this.name = obj.name;
    this.value = obj.value;
    this.sort = obj.sort;
    this.width = obj.width;
    this.valueIsNumber = obj.valueIsNumber;
    this.customSorter = obj.customSorter;
    this.icon = obj.icon;
    this.hidden = obj.hidden;
  }
}

export interface LocLabel {
  key: string;
  modifier?: LocLabelModifier;
  replaceMap?: ReplaceMap;
}

export function parseLocLabelArgs(arg1: StrValue<LocLabelModifier> | ReplaceMap | undefined, arg2: ReplaceMap | undefined) {
  let modifier: LocLabelModifier | undefined;
  let replaceMap: ReplaceMap | undefined;

  if (arg2) {
    modifier = arg1 as LocLabelModifier;
    replaceMap = arg2;
  } else if (typeof arg1 == 'object') {
    replaceMap = arg1;
  } else {
    modifier = arg1 as LocLabelModifier;
  }

  return { modifier, replaceMap };
}

export enum LocLabelModifier {
  CAP = 'capitalize',
  UPPER = 'uppercase',
  LOWER = 'lowercase'
}
